import type { ChatMessage, FileRecord } from '@reados/contracts';

/** One complete source program, owned by an immutable file-content revision.
 * This is a presentation DTO only; it never creates a persisted chat or turn. */
export function documentMessage(document: Pick<FileRecord, 'id' | 'contentRevision'>, source: string): ChatMessage {
  return { id: `document:${document.id}:${document.contentRevision}`, role: 'assistant', text: source, status: 'complete' };
}
